import {required} from "vuelidate/lib/validators"; 
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 

const StrStratejikAmac = {
  mixins: [Api, Sabit],
    data() {
      return { 
        StrStratejikAmacData:{
          Donemid: null,
            Aciklama: "",
            Deleted: false,
        },
        FormDataType:{ 
          Donemid:{FieldName:"Donemid",Field:"combobox",FieldTitle:this.$t('StrPerfTablo.AddEdit.DonemId'),ComboDataArray:[]},
          Aciklama:{FieldName:"Aciklama",Field:"input",FieldTitle:this.$t('StrStratejikAmac.AddEdit.Aciklama'),FieldType:"text"},
        }
      }
    
    },

    validations:{ 
        FormData: {   
          Donemid:{ required },
          Aciklama: { required }
        } 
    },

    created(){ 
      let Page= {
        PageNumber: "1",
        PageSize: "9999"
      }

      this.FormDataType.Donemid.ComboDataArray=[];

                   
          
      let sorgu = "&Tip=1561";
      let Tip=[];
        
        this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:sorgu}).then((res) => {
          console.log(res)
            for(var i=0; i<res.Data.length; i++)
            {   
                if(res.Data[i].Kod==1 || res.Data[i].Kod==2  || res.Data[i].Kod==5) { 
                    Tip.push(res.Data[i].Id);       
                }            
            }

            let altsorgu="&UstIdDoluMu=false&Approval=true";

            let tipler="";

            for (var s=0; s<Tip.length; s++){

                tipler=tipler+"&TipId="+Tip[s];

            }

            altsorgu=altsorgu+tipler;

         

            this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: altsorgu }).then((res) => {
            for (var i = 0; i < res.Data.length; i++) {
        
               
                this.FormDataType.Donemid.ComboDataArray.push ({id:res.Data[i].Id,label:res.Data[i].Aciklama})
              
            }
          });
     
        });





        
         
    }




}

export default StrStratejikAmac